import { Store } from "vuex";
import { CitationState, GetUserPayload } from "./citation.types";
import { citationApi } from "@/api/citation.api";
import { ApiStatus } from "@/store/general.types";

export const citationActions = {
    async getUser(
        store: Store<CitationState>,
        payload: GetUserPayload
    ) {
        try {
            store.commit('GET_USER_MUTATION', ApiStatus.LOADING);

            const { data } = await citationApi.getUser(payload);
            store.commit('GET_USER_MUTATION', { data });
        } catch (error) {
            store.commit('GET_USER_MUTATION', { error });
        }
    }
}